export const LandingPageActivityPeriods = [
  {identifier: 'today', label: 'Active today', shortLabel: 'Today'},
  {identifier: 'yesterday', label: 'Active since yesterday', shortLabel: 'Yesterday'},
  {identifier: 'this-week', label: 'Active this week', shortLabel: 'This week'},
  {identifier: 'last-week', label: 'Active since last week', shortLabel: 'Last week'},
  {identifier: 'last-month', label: 'Active since last month', shortLabel: 'Last month'},
  {identifier: 'this-year', label: 'Active this year', shortLabel: 'This year'},
];
